"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Quarter Management",
  subtitle: "Manage quarters",
  listEndpoint: "quatermanagement/quater-list",
  countEndpoint: "quatermanagement/quater-list-count",
  deleteEndpoint: "quatermanagement/Quarter-delete",
  statusEndpoint: "quatermanagement/quarter-status-change",
  addPath: "/admin/quarters/add",
  editPath: "/admin/quarters/edit",
  addButtonLabel: "+ Add Quarter",
  columns: [
    { key: "quarter_name", label: "Quarter Name", sortable: true },
    { key: "sit_count", label: "Sit Count" },
    { key: "description", label: "Description" },
    { key: "status", label: "Status", type: "status" },
    { key: "priority", label: "Priority" },
    // Q-05: Angular shows updated_at not created_at
    { key: "updated_at", label: "Updated On", type: "date", sortable: true },
  ],
  // Q-07: Add search and filter
  searchFields: [
    { label: "Quarter Name", field: "quarter_name", placeholder: "Search by quarter name..." },
  ],
  filterFields: [
    {
      label: "Status",
      field: "status",
      values: [
        { val: "1", name: "Active" },
        { val: "0", name: "Inactive" },
      ],
    },
  ],
  // QM-01: Updated-date range filter
  dateRangeFields: [
    { label: "Updated Date", field: "updated_at" },
  ],
  // QM-01: Row preview using already-fetched list data
  previewFromRow: true,
  previewFields: [
    { key: "quarter_name", label: "Quarter Name" },
    { key: "sit_count", label: "Sit Count" },
    { key: "description", label: "Description", type: "html" },
    { key: "priority", label: "Priority" },
    { key: "status", label: "Status", type: "badge" },
    { key: "updated_at", label: "Updated On", type: "date" },
  ],
  // QM-01: Bulk actions (bulk status-change and bulk delete) not yet implemented
  // in GenericListPage — GenericListPage has no multi-select infrastructure.
  // Deferred: would require adding row-checkbox selection and bulk action bar to the
  // shared component, which is a significant cross-cutting change outside this task scope.
};

export default function QuartersPage() {
  return <GenericListPage config={config} />;
}
